export enum AppEvents {
  FETCH_OFFERS = 'fetch:offers',
  FETCH_PROMO_OFFERS = 'fetch:promo-offers',
  FETCH_COURSES = 'fetch:courses',
  FETCH_STEPS = 'fetch:steps',
  FETCH_USER_DATA = 'fetch:user-data',
  FETCH_SALES_REP_DATA = 'fetch:sales-rep-data',
  SHOW_PREV_PRODUCT = 'show:prev-product',
  SHOW_PREV_PRODUCT__PROMO = 'show:prev-product-promo',
  SHOW_PREV_PRODUCT__OFFER = 'show:prev-product-offer',
  SHOW_PREV_PRODUCT__COURSE = 'show:prev-product-course',
  SHOW_NEXT_PRODUCT = 'show:next-product',
  SHOW_NEXT_PRODUCT__PROMO = 'show:next-product-promo',
  SHOW_NEXT_PRODUCT__OFFER = 'show:next-product-offer',
  SHOW_NEXT_PRODUCT__COURSE = 'show:next-product-course',
  CLOSE_MODAL = 'close:modal',
  SCROLL_CHAT_MESSAGES = 'scroll-chat-messages',
  MARKETPLACE_FETCH_OFFERS = 'marketplace:fetch-offers',
  FETCH_CONTACTS = 'fetch:contacts',
  SEARCH_OFFERS = 'search:offers',
  FETCH_CHATS = 'fetch:chats',
  FETCH_PREV_MESSAGES = 'fetch:previous-messages',
  FETCH_AI_MESSAGES = 'fetch:ai-messages',
  RESET_CHAT_DATA = 'reset:chat-data',
  FETCH_ORDERS = 'fetch:orders',
  MARKETPLACE_FETCH_OFFERS_INIT = 'marketplace:fetch-offer-init',
  GET_BRIEF_ITEMS = 'get:briefItems',
}
